import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-liste-ruchers',
  templateUrl: './liste-ruchers.component.html',
  styleUrls: ['./liste-ruchers.component.css']
})
export class ListeRuchersComponent implements OnInit {
  options: String[];

  constructor(private appService: AppService, private router: Router, private route: ActivatedRoute) {
    this.options = ["One", "Two", "Three"];
  }

  ngOnInit() {
    if (this.appService.nomenclatures.length === 0) {
      this.router.navigate(['']);
    } 
  }

  afficheInterventionsRucher(id_rucher: string) {
    this.router.navigate(['inter', id_rucher], { skipLocationChange: true, relativeTo: this.route });
  }

}



// WEBPACK FOOTER //
// ./src/app/principal/interventions/liste-ruchers/liste-ruchers.component.ts